// @flow
import { LoginActionTypes } from "./constants";

export const setSmsSent = (bool) => ({
  type: LoginActionTypes.SET_SMS_SENT,
  payload: bool,
});

export const setSmsSentFailure = (bool) => ({
  type: LoginActionTypes.SET_SMS_SENT_FAILURE,
  payload: bool,
});

export const setPhoneNumber = (text) => ({
  type: LoginActionTypes.SET_PHONE_NUMBER,
  payload: text,
});

export const setPhoneChar = (number) => ({
  type: LoginActionTypes.SET_PHONE_CHAR,
  payload: number,
});

export const setPhoneValid = (bool) => ({
  type: LoginActionTypes.SET_PHONE_VALID,
  payload: bool,
});

export const setVerificationCodeValid = (bool) => ({
  type: LoginActionTypes.SET_VERIFICATION_CODE_VALID,
  payload: bool,
});

export const setVerificationCode = (text) => ({
  type: LoginActionTypes.SET_VERIFICATION_CODE,
  payload: text,
});

export const setVerificationCodeLength = (number) => ({
  type: LoginActionTypes.SET_VERIFICATION_CODE_LENGTH,
  payload: number,
});

export const resetLoginStates = () => ({
  type: LoginActionTypes.RESET_LOGIN_STATES,
  payload: true
});

export const setVerificationCodeNotAccepted = (bool) => ({
  type: LoginActionTypes.SET_VERIFICATION_CODE_NOT_ACCEPTED,
  payload: bool
});
